module.exports = __webpack_public_path__ + "img/0c2d6947fa76464b8d3e79e4c8a7798a-1440.6f3f1b12.jpg";